if (!customElements.get('selling-plan-toggle')) {
    customElements.define(
        'selling-plan-toggle',
        class SellingPlanToggle extends HTMLElement {
            constructor() {
                super();
                this.sellingPlan = this.querySelector('input[name="selling_plan"]');
                this.option = this.querySelector('input[name="purchasedOption"]');
                this.intervalFrequency = this.querySelector('select[name="rc_shipping_interval_frequency"]');
                this.autodeliverOptions = this.querySelector('.rc_label.rc_label__deliver_every');
                this.switchToSubscription = this.querySelector('.rc_block__switch-to-subscription');
                this.form = this.closest('product-form');
                this.submitButton = this.form.querySelector('.product-form__submit');
                this.stickyAtc = document.querySelector('.sticky-wrapper') || null;
                this.priceEls = document.querySelectorAll('[data-product-price]');

                this.switchToSubscription.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.querySelector('input[name="purchasedOption"]').checked = true;
                    this.onSellingPlanChange();
                });

                this.onSellingPlanChange();
                this.addEventListener('change', this.onSellingPlanChange);
                this.stickyAtc?.querySelector('#sticky_rc_shipping_interval_frequency').addEventListener('change', this.onStickySellingPlanChange.bind(this));
                window.addEventListener('ReChargeWidget-loaded', (e) => {
                    if (!window.ReChargeWidget.eventService) return;
                    window.ReChargeWidget.eventService.addEventListener('widget:build', (e) => {
                        window.ReChargeWidget.destroyAllWidgets();
                        if (!this.option.checked) {
                            setTimeout(() => {
                                this.sellingPlan.value = '';
                            }, 100);
                        }
                    });
                });

                const labels = Array.from(this.querySelectorAll('.rc_block label'));
                labels.forEach((label) => {
                    label.addEventListener(
                        'keypress',
                        function (evt) {
                            const input = evt.target.querySelector('input[type="radio"]') || evt.target.querySelector('input[type="checkbox"]');
                            if (evt.key === ' ' && input) {
                                evt.preventDefault();
                                input.click();
                            }
                        },
                        false
                    );
                });
            }

            onSellingPlanChange() {
                this.optionOneTime = this.querySelector('input[name="purchasedOption"]');
                this.optionSub = this.querySelector('input[name="purchasedOption"]:checked');
                this.label = this.querySelector('.rc-checkbox__label-text');
                this.labelPrices = this.querySelector('.rc-checkbox__label-prices');
                this.labelBadge = this.querySelector('.rc-checkbox__label-badge');
                this.oneTimeBlock = this.querySelector('.rc_block__type__onetime');
                this.subBlock = this.querySelector('.rc_block__type__autodeliver');
                this.oneTimeLabel = this.oneTimeBlock.getAttribute('data-option-label');
                this.subLabel = this.subBlock.getAttribute('data-option-label');

                var isSubscription = this.optionSub;
                this.activeBlock = this.querySelector('.rc_block__type.rc_block__type--active');
                if (this.activeBlock) {
                    this.activeBlock.classList.remove('rc_block__type--active');
                }
                if (this.optionSub) {
                    this.querySelector('.rc_block__type__autodeliver').classList.add('rc_block__type--active');
                    this.label.textContent = this.subLabel;
                    this.labelBadge?.classList.remove('hidden');
                    this.sellingPlan.value = this.intervalFrequency?.value;
                    this.autodeliverOptions.classList.add('show');

                    this.stickyAtc?.querySelector('#sticky_rc_shipping_interval_frequency').classList.remove('hidden');
                } else {
                    this.querySelector('.rc_block__type__onetime').classList.add('rc_block__type--active');
                    this.label.textContent = this.oneTimeLabel;
                    this.labelBadge?.classList.add('hidden');
                    this.sellingPlan.value = '';
                    this.autodeliverOptions.classList.remove('show');

                    this.stickyAtc?.querySelector('#sticky_rc_shipping_interval_frequency').classList.add('hidden');
                }

                // Update the price on the submit button on selling plan change
                let currentPrice, currentComparePrice;

                if (this.optionSub) {
                    currentPrice = this.subBlock.getAttribute('data-price');
                    currentComparePrice = this.subBlock.getAttribute('data-compare-at-price');

                    const frequencySelect = this.querySelector('#rc_shipping_interval_frequency');

                    if (frequencySelect?.options[frequencySelect.selectedIndex]) {
                        const activeSubscriptionPrice = frequencySelect.options[frequencySelect.selectedIndex].attributes.price.value;
                        const subPriceElement = this.optionOneTime.closest('.rc-checkbox').querySelector('.rc_text_price');
                        const metafieldPrice = subPriceElement?.getAttribute('data-metafield-price');

                        if (metafieldPrice) {
                            currentPrice = metafieldPrice;
                            subPriceElement.textContent = metafieldPrice;
                        } else {
                            currentPrice = activeSubscriptionPrice;
                            subPriceElement.textContent = activeSubscriptionPrice;
                        }
                    }
                } else {
                    currentPrice = this.oneTimeBlock.getAttribute('data-price');
                    currentComparePrice = this.oneTimeBlock.getAttribute('data-compare-at-price');
                }

                const buttonPriceAll = this.submitButton.querySelectorAll('.button-price');
                const buttonComparePriceAll = this.submitButton.querySelectorAll('.compare-at-price');
                const labelButtonPriceAll = this.labelPrices.querySelectorAll('.button-price');
                const labelButtonComparePriceAll = this.labelPrices.querySelectorAll('.compare-at-price');

                buttonPriceAll.forEach((buttonPrice) => {
                    buttonPrice.innerHTML = currentPrice;
                    buttonPrice.setAttribute('aria-label', `Sale price ${currentPrice}`);

                    if (!isSubscription) {
                        buttonPrice.classList.remove('igPrice');
                    }

                    void buttonPrice.offsetWidth;
                })
                labelButtonPriceAll.forEach((labelButtonPrice) => {
                    labelButtonPrice.textContent = currentPrice;
                    if (!isSubscription) {
                        labelButtonPrice.classList.remove('igPrice');
                    }

                    void labelButtonPrice.offsetWidth;
                })
                buttonComparePriceAll.forEach((buttonComparePrice) => {
                    buttonComparePrice.innerHTML = currentComparePrice;
                    if (currentComparePrice && currentComparePrice !== '$0.00' && currentComparePrice !== null && currentComparePrice !== 'null') {
                        buttonComparePrice.setAttribute('aria-label', `Regular price ${currentComparePrice}`);
                        buttonComparePrice.classList.remove('!hidden');
                    } else {
                        buttonComparePrice.classList.add('!hidden');
                        buttonComparePrice.removeAttribute('aria-label');
                    }
                    void buttonComparePrice.offsetWidth;
                });
                labelButtonComparePriceAll.forEach((labelButtonComparePrice) => {
                    labelButtonComparePrice.innerHTML = currentComparePrice;
                    if (currentComparePrice && currentComparePrice !== '$0.00' && currentComparePrice !== null && currentComparePrice !== 'null') {
                        labelButtonComparePrice.classList.remove('!hidden');
                    } else {
                        labelButtonComparePrice.classList.add('!hidden');
                    }
                    void labelButtonComparePrice.offsetWidth;
                })

                this.updatePriceEls();

                // Check for sticky ATC
                if (this.stickyAtc) {
                    const buttonPriceAll = this.stickyAtc.querySelectorAll('.button-price');
                    const buttonComparePriceAll = this.stickyAtc.querySelector('.compare-at-price');

                    buttonPriceAll.forEach((buttonPrice) => {
                        buttonPrice.innerHTML = currentPrice;
                        buttonPrice.setAttribute('aria-label', `Sale price ${currentPrice}`);
                        if (!isSubscription) {
                            buttonPrice.classList.remove('igPrice');
                        }
                        void buttonPrice.offsetWidth;
                    })
                    buttonComparePriceAll.forEach((buttonComparePrice) => {
                        buttonComparePrice.innerHTML = currentComparePrice;
                        if (currentComparePrice && currentComparePrice !== '$0.00' && currentComparePrice !== null && currentComparePrice !== 'null') {
                            buttonComparePrice.setAttribute('aria-label', `Regular price ${currentComparePrice}`);
                            buttonComparePrice.classList.remove('!hidden');
                        } else {
                            buttonComparePrice.removeAttribute('aria-label');
                            buttonComparePrice.classList.add('!hidden');
                        }
                        void buttonComparePrice.offsetWidth;
                    })
                }
            }

            updatePriceEls() {
                const isSubscription = Boolean(this.optionSub);

                let currentPrice, currentComparePrice;

                if (this.optionSub) {
                    currentPrice = this.subBlock.getAttribute('data-price');
                    currentComparePrice = this.subBlock.getAttribute('data-compare-at-price');

                    const frequencySelect = this.querySelector('#rc_shipping_interval_frequency');

                    if (frequencySelect?.options[frequencySelect.selectedIndex]) {
                        const activeSubscriptionPrice = frequencySelect.options[frequencySelect.selectedIndex].attributes.price.value;
                        const subPriceElement = this.optionOneTime.closest('.rc-checkbox').querySelector('.rc_text_price');
                        const metafieldPrice = subPriceElement?.getAttribute('data-metafield-price');

                        if (metafieldPrice) {
                            currentPrice = metafieldPrice;
                        } else {
                            currentPrice = activeSubscriptionPrice;
                        }
                    }
                } else {
                    currentPrice = this.oneTimeBlock.getAttribute('data-price');
                    currentComparePrice = this.oneTimeBlock.getAttribute('data-compare-at-price');
                }

                this.priceEls.forEach(priceEl => {
                    const price = priceEl.querySelector('.product-price');
                    const comparePrice = priceEl.querySelector('.compare-at-price');

                    if (price) {
                        price.innerHTML = currentPrice;
                        price.setAttribute('aria-label', `Sale price ${currentPrice}`);
                        if (!isSubscription) {
                            price.classList.remove('igPrice');
                        }
                    }

                    if (comparePrice) {
                        if (currentComparePrice && currentComparePrice !== '$0.00' && currentComparePrice !== null && currentComparePrice !== 'null') {
                            comparePrice.innerHTML = `<s>${currentComparePrice}</s>`;
                            comparePrice.setAttribute('aria-label', `Regular price ${currentComparePrice}`);
                            comparePrice.classList.remove('!hidden');
                        } else {
                            comparePrice.innerHTML = '';
                            comparePrice.removeAttribute('aria-label');
                            comparePrice.classList.add('!hidden');
                        }
                    }
                })

                this.updatePricePerDayEls(currentPrice);
            }

            updatePricePerDayEls(currentPriceStr) {
                if (!currentPriceStr) return;
                const priceNum = parseFloat(String(currentPriceStr).replace(/[^0-9.]/g, ''));
                if (isNaN(priceNum) || priceNum <= 0) return;
                document.querySelectorAll('[data-price-per-day]').forEach(el => {
                    const days = parseInt(el.dataset.days, 10);
                    if (!days || days <= 0) return;
                    el.textContent = `Only $${(priceNum / days).toFixed(2)}/day`;
                });
            }

            onStickySellingPlanChange() {
                const activePlan = this.stickyAtc.querySelector('#sticky_rc_shipping_interval_frequency').value;
                const buyboxSelect = document.querySelector('selling-plan-toggle');

                buyboxSelect.querySelector('select[name="rc_shipping_interval_frequency"]').value = activePlan;
                buyboxSelect.dispatchEvent(new Event('change'));
            }
        }
    );
}

// Original selling plan radios (keep until A/B test is complete)

class SellingPlanRadios extends HTMLElement {
    constructor() {
        super();
        this.initElements();
        this.addEventListeners();
        this.onSellingPlanChange();

        if (this.querySelectorAll('.rc_plan_option').length) {
            this.onSeparateSellingPlanChange();
        }
    }

    initElements() {
        this.sellingPlan = this.querySelector('input[name="selling_plan"]');
        this.selectedOption = this.querySelector('input[name="purchasedOption"]:checked');
        this.intervalFrequency = this.querySelector('select[name="rc_shipping_interval_frequency"]');
        this.autodeliverOptions = this.querySelector('.rc_label.rc_label__deliver_every');
        this.form = this.closest('product-form');
        this.submitButton = this.form.querySelector('.product-form__submit');
        this.stickyAtc = document.querySelector('.sticky-wrapper') || null;
        this.priceEls = document.querySelectorAll('[data-product-price]');
        if (this.querySelectorAll('.rc_plan_option').length) {
            this.closest('form').classList.add('loading');
        }
    }

    addEventListeners() {
        this.addEventListener('change', this.onSellingPlanChange.bind(this));
        this.querySelectorAll('.rc_plan_option').forEach((option) => {
            option.addEventListener('click', this.onSeparateSellingPlanChange.bind(this));
        });
        this.stickyAtc?.querySelector('#sticky_rc_shipping_interval_frequency').addEventListener('change', this.onStickySellingPlanChange.bind(this));
        window.addEventListener('ReChargeWidget-loaded', this.onReChargeWidgetLoaded.bind(this));
        this.querySelectorAll('.rc_block label').forEach((label) => {
            label.addEventListener('keypress', this.onLabelKeyPress.bind(this), false);
        });
    }

    onSellingPlanChange(event) {
        this.updateVendorSellingPlan();
        this.updatePurchasedOption();
        this.updateActiveBlock();
        this.updateSellingPlanValue();
        this.updateUrlParams(event);
        this.updateButtonPrices();
        this.updatePriceEls();
        setTimeout(() => {
            this.updateStickyAtcPrices();
        }, 1000);
    }

    updateVendorSellingPlan() {
        this.vendorSellingPlan = this.closest('form')?.querySelector('.rc-container-wrapper [name="selling_plan"]');

        if (this.vendorSellingPlan) {
            this.vendorSellingPlan.setAttribute('name', 'rc_selling_plan');
        }
    }

    updatePurchasedOption() {
        this.purchasedOption = this.querySelector('input[name="purchasedOption"]:checked');
        publish(PUB_SUB_EVENTS.sellingPlanChange, {option: this.purchasedOption.value});
    }

    updateActiveBlock() {
        this.activeBlock = this.querySelector('.rc_block__type.rc_block__type--active');
        this.activeBlock?.classList.remove('rc_block__type--active');
        this.purchasedOption.closest('.rc_block').classList.add('rc_block__type--active');
    }

    updateSellingPlanValue() {
        if (this.purchasedOption.value === 'onetime') {
            this.sellingPlan.value = '';
            this.autodeliverOptions.classList.remove('show');
            this.stickyAtc?.querySelector('#sticky_rc_shipping_interval_frequency').classList.add('hidden');
        } else {
            this.sellingPlan.value = this.intervalFrequency?.value || this.querySelector('.rc_plan_option--selected')?.getAttribute('value');
            this.autodeliverOptions.classList.add('show');
            this.stickyAtc?.querySelector('#sticky_rc_shipping_interval_frequency').classList.remove('hidden');
        }
    }

    updateUrlParams(event) {
        if (this.querySelectorAll('.rc_plan_option').length) {
            const url = new URL(window.location);
            if (event) {
                const activeBlockClass = this.querySelector('.rc_block__type.rc_block__type--active').classList;
                url.searchParams.set('delivery_type', activeBlockClass.contains('rc_block__type__autodeliver') ? 'subscription' : 'onetime');
                window.history.pushState({}, '', url);
            }
            this.checkUrlParams(url);
        }
    }

    checkUrlParams(url) {
        if (url.searchParams.has('delivery_type', 'subscription') && !this.querySelector('.rc_block__type__autodeliver').classList.contains('rc_block__type--active')) {
            this.querySelector('.rc_block__type__autodeliver input[name="purchasedOption"]').checked = true;
            this.onSellingPlanChange();
        } else if (url.searchParams.has('delivery_type', 'onetime') && !this.querySelector('.rc_block__type__onetime').classList.contains('rc_block__type--active')) {
            this.querySelector('.rc_block__type__onetime input[name="purchasedOption"]').checked = true;
            this.onSellingPlanChange();
        }
    }

    updatePriceEls() {
        const isSubscription = this.purchasedOption.value === 'subscription';

        const priceElement = this.purchasedOption.closest('.rc_block').querySelector('.rc_text_price');
        const metafieldPrice = priceElement?.getAttribute('data-metafield-price');
        let currentPrice = priceElement?.textContent || '';
        let currentComparePrice = priceElement?.getAttribute('data-com-price') || '';

        if (isSubscription) {
            const frequencySelect = this.querySelector('#rc_shipping_interval_frequency');
            if (frequencySelect?.options[frequencySelect.selectedIndex] && !metafieldPrice) {
                const activeSubscriptionPrice = frequencySelect.options[frequencySelect.selectedIndex].attributes.price.value;
                currentPrice = activeSubscriptionPrice;
            } else if (metafieldPrice) {
                currentPrice = metafieldPrice;
            }
        }

        this.priceEls.forEach(priceEl => {
            const price = priceEl.querySelector('.product-price');
            const comparePrice = priceEl.querySelector('.compare-at-price');

            if (price) {
                price.innerHTML = currentPrice;
                price.setAttribute('aria-label', `Sale price ${currentPrice}`);
                if (!isSubscription) {
                    price.classList.remove('igPrice');
                }
            }

            if (comparePrice) {
                if (currentComparePrice && currentComparePrice !== '$0.00' && currentComparePrice !== null && currentComparePrice !== 'null') {
                    comparePrice.innerHTML = `<s>${currentComparePrice}</s>`;
                    comparePrice.setAttribute('aria-label', `Regular price ${currentComparePrice}`);
                    comparePrice.classList.remove('!hidden');
                } else {
                    comparePrice.innerHTML = '';
                    comparePrice.removeAttribute('aria-label');
                    comparePrice.classList.add('!hidden');
                }
            }
        })

        this.updatePricePerDayEls(currentPrice);
    }

    updatePricePerDayEls(currentPriceStr) {
        if (!currentPriceStr) return;
        const priceNum = parseFloat(String(currentPriceStr).replace(/[^0-9.]/g, ''));
        if (isNaN(priceNum) || priceNum <= 0) return;
        document.querySelectorAll('[data-price-per-day]').forEach(el => {
            const days = parseInt(el.dataset.days, 10);
            if (!days || days <= 0) return;
            el.textContent = `Only $${(priceNum / days).toFixed(2)}/day`;
        });
    }

    updateButtonPrices() {
        const subPriceElement = this.purchasedOption.closest('.rc_block').querySelector('.rc_text_price');
        const metafieldPrice = subPriceElement?.getAttribute('data-metafield-price');
        let currentPrice = subPriceElement.textContent;
        const currentComparePrice = subPriceElement.getAttribute('data-com-price');
        const frequencySelect = this.querySelector('#rc_shipping_interval_frequency');
        const isSubscription = this.purchasedOption.value == 'subscription';

        if (frequencySelect?.options[frequencySelect.selectedIndex] && isSubscription && !metafieldPrice) {
            const activeSubscriptionPrice = frequencySelect.options[frequencySelect.selectedIndex].attributes.price.value;
            subPriceElement.textContent = activeSubscriptionPrice;
            currentPrice = activeSubscriptionPrice;
        } else if (metafieldPrice) {
            currentPrice = metafieldPrice;
            subPriceElement.textContent = metafieldPrice;
        }

        this.updateSubmitButtonPrices(currentPrice, currentComparePrice, isSubscription);
    }

    updateSubmitButtonPrices(currentPrice, currentComparePrice, isSubscription) {
        const buttonPriceAll = this.submitButton.querySelectorAll('.button-price');
        const buttonComparePriceAll = this.submitButton.querySelectorAll('.compare-at-price');

        buttonPriceAll.forEach((buttonPrice) => {
            buttonPrice.innerHTML = currentPrice;
            buttonPrice.setAttribute('aria-label', `Sale price ${currentPrice}`);
            if (!isSubscription) {
                buttonPrice.classList.remove('igPrice');
            }
            void buttonPrice.offsetWidth;
        })

        buttonComparePriceAll.forEach((buttonComparePrice) => {
            buttonComparePrice.innerHTML = currentComparePrice;
            if (currentComparePrice && currentComparePrice !== '$0.00' && currentComparePrice !== null && currentComparePrice !== 'null') {
                buttonComparePrice.setAttribute('aria-label', `Regular price ${currentComparePrice}`);
                buttonComparePrice.classList.remove('!hidden');
            } else {
                buttonComparePrice.removeAttribute('aria-label');
                buttonComparePrice.classList.add('!hidden');
            }
            void buttonComparePrice.offsetWidth;
        })
    }

    updateStickyAtcPrices() {
        if (this.stickyAtc) {
            const buttonPriceAll = this.stickyAtc.querySelectorAll('.button-price');
            const buttonComparePriceAll = this.stickyAtc.querySelectorAll('.compare-at-price');
            const currentPrice = this.purchasedOption.closest('.rc_block').querySelector('.rc_text_price').textContent;
            const currentComparePrice = this.purchasedOption.closest('.rc_block').querySelector('.rc_text_price').getAttribute('data-com-price');
            const isSubscription = this.purchasedOption.value == 'subscription';

            buttonPriceAll.forEach((buttonPrice) => {
                buttonPrice.innerHTML = currentPrice;
                buttonPrice.setAttribute('aria-label', `Sale price ${currentPrice}`);
                if (!isSubscription) {
                    buttonPrice.classList.remove('igPrice');
                }
                void buttonPrice.offsetWidth;
            })

            buttonComparePriceAll.forEach((buttonComparePrice) => {
                buttonComparePrice.innerHTML = currentComparePrice;
                if (currentComparePrice && currentComparePrice !== '$0.00' && currentComparePrice !== null && currentComparePrice !== 'null') {
                    buttonComparePrice.setAttribute('aria-label', `Regular price ${currentComparePrice}`);
                    buttonComparePrice.classList.remove('!hidden');
                } else {
                    buttonComparePrice.removeAttribute('aria-label');
                    buttonComparePrice.classList.add('!hidden');
                }
                void buttonComparePrice.offsetWidth;
            })
        }
    }

    onSeparateSellingPlanChange(event) {
        const selectedOptionValue = this.querySelector('.rc_plan_option--selected').getAttribute('value');
        const selectedOptionVariant = this.querySelector('.rc_plan_option--selected').getAttribute('data-plan-variant-id');

        if (event) {
            this.querySelector('.rc_block__type__autodeliver input[name="purchasedOption"]').click();
            const selectedNewVariant = event.target.closest('.rc_plan_option').getAttribute('data-plan-variant-id');
            if (selectedOptionVariant !== selectedNewVariant) {
                this.querySelector('input[data-option-variant-id="' + selectedNewVariant + '"]').click();
            }
            this.closest('form').classList.remove('loading');
        } else {
            this.updateSellingPlanInput(selectedOptionValue);
        }

        if (!document.querySelector('body').classList.contains('recharge--loaded')) {
            document.querySelector('body').classList.add('recharge--loaded');
        }
    }

    updateSellingPlanInput(selectedOptionValue) {
        const bodyClassList = document.querySelector('body').classList;
        const autodeliverActive = this.querySelector('.rc_block__type__autodeliver').classList.contains('rc_block__type--active');
        const form = this.closest('form');
        const sellingPlanInput = this.querySelector('input[name="selling_plan"]');

        if (autodeliverActive) {
            if (!bodyClassList.contains('recharge--loaded')) {
                setTimeout(() => {
                    sellingPlanInput.value = selectedOptionValue;
                    form.classList.remove('loading');
                }, 1500);
            } else {
                sellingPlanInput.value = selectedOptionValue;
                form.classList.remove('loading');
            }
        } else {
            sellingPlanInput.value = '';
            form.classList.remove('loading');
        }
    }

    onStickySellingPlanChange() {
        const activePlan = this.stickyAtc.querySelector('#sticky_rc_shipping_interval_frequency').value;
        const buyboxSelect = document.querySelector('selling-plan-radios');
        buyboxSelect.querySelector('select[name="rc_shipping_interval_frequency"]').value = activePlan;
        buyboxSelect.dispatchEvent(new Event('change'));
    }

    onReChargeWidgetLoaded() {
        if (!window.ReChargeWidget.eventService) return;
        window.ReChargeWidget.eventService.addEventListener('widget:build', () => {
            window.ReChargeWidget.destroyAllWidgets();
            if (this.selectedOption.value === 'onetime') {
                setTimeout(() => {
                    this.sellingPlan.value = '';
                }, 100);
            }
        });
    }

    onLabelKeyPress(evt) {
        const input = evt.target.querySelector('input[type="radio"]') || evt.target.querySelector('input[type="checkbox"]');
        if (evt.key === ' ' && input) {
            evt.preventDefault();
            input.click();
        }
    }
}

if (!customElements.get('selling-plan-radios')) {
    customElements.define('selling-plan-radios', SellingPlanRadios);
}
